import React from 'react';
import Login from '../../pages/Login';

const displayName = 'LayoutPublic';

const Public = () => <Login />;

Public.displayName = displayName;
export default Public;
